enum EMerchantMode {
  SALES = 'sales',
  TEST = 'test',
}

export default EMerchantMode;
